/**
 * Notification type and content-type constants.
 *
 * ⚠️ Extracted from `api-notifications.js` so that module can import `feedAdapter`, which needs
 * `TYPES` — importing it the other way round is a dependency cycle the linter rejects. Nothing
 * here has behaviour; it is the shared vocabulary `circleCopy`, `notificationCategory` and the
 * two render switches all branch on.
 *
 * `api-notifications` re-exports both, so existing importers are unaffected.
 *
 * @module services/notifications/types
 */

export const TYPES = {
  SUBSCRIPTION_RECOMMENDATION: 'SUBSCRIPTION_RECOMMENDATION',
  SUBSCRIPTION_NEW_EPISODE: 'SUBSCRIPTION_NEW_EPISODE',
  SUBSCRIPTION_NEW_SEASON: 'SUBSCRIPTION_NEW_SEASON',
  SUBSCRIPTION_FREE_FORM: 'SUBSCRIPTION_FREE_FORM',
  GENERAL_VIDEO_PROMOTION: 'GENERAL_VIDEO_PROMOTION',
  GENERAL_RECOMMENDATION: 'GENERAL_RECOMMENDATION',
  GENERAL_NEW_FEATURE: 'GENERAL_NEW_FEATURE',
  GENERAL_FREE_FORM: 'GENERAL_FREE_FORM',
  MEMBER_RECOMMENDATION: 'MEMBER_RECOMMENDATION',
  MEMBER_PLAYLIST_ADD: 'MEMBER_PLAYLIST_ADD',
  MEMBER_FREE_FORM: 'MEMBER_FREE_FORM',
  MEMBER_FOLLOWING: 'MEMBER_FOLLOWING',
  ACCOUNT_FOLLOWED: 'ACCOUNT_FOLLOWED',
  CIRCLE_NEW_MESSAGE: 'CIRCLE_NEW_MESSAGE',
  CIRCLE_OPENED: 'CIRCLE_OPENED',
  CIRCLE_INVITE: 'CIRCLE_INVITE',
  CIRCLE_REPLY: 'CIRCLE_REPLY',
  CIRCLE_MEMBER_ADDED: 'CIRCLE_MEMBER_ADDED',
  CIRCLE_REACTION: 'CIRCLE_REACTION',
  MODERATION_MEMBER_COMMUNICATION: 'MODERATION_MEMBER_COMMUNICATION',
  COMMENT_REJECTED: 'COMMENT_REJECTED',
  COMMENT_REPLY: 'COMMENT_REPLY',
  COMMENT_MENTION: 'COMMENT_MENTION',
  PROFILE_FOLLOWED: 'PROFILE_FOLLOWED',
}

export const CONTENT_TYPES = {
  SUBSCRIPTION: 'subscription',
  MEMBER: 'member',
  SERIES: 'series',
  VIDEO: 'video',
}
